import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import * as labels from "config.labels";
import { useDispatch, useSelector } from "react-redux";
import * as pricingActions from "store/actions/pricing/pricingActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as pricingSelectors from "store/selectors/pricing/pricingSelectors";
import * as stateSelectors from "store/selectors/stateSelectors";
import * as utils from "utils";

const NONE_KEY = "__NONE__";

const RenewedFromLayerSelector = ({ disabled }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const dispatch = useDispatch();

  const layer = useSelector(pricingSelectors.selectResolvedActiveLayer);

  const priorLayers =
    useSelector((state) =>
      pricingSelectors.selectResolvedLayers(
        stateSelectors.selectPriorState(state)
      )
    ) ?? [];

  const choices = priorLayers.map((priorLayer) => ({
    key: priorLayer.id,
    name: utils.shortLayerName(priorLayer),
  }));

  return (
    <FormControl variant={"filled"} fullWidth>
      <InputLabel className={"input-label"}>
        {translateLabel(labels.RENEWED_FROM_LAYER_LABEL, {
          default: "Renewed From Layer",
        })}
      </InputLabel>
      <Select
        value={layer?.renewedFromId || NONE_KEY}
        onChange={(event) => {
          const value = event?.target?.value || NONE_KEY;
          const renewedFromId = value === NONE_KEY ? null : value;
          dispatch(
            pricingActions.updateLayer({
              layerId: layer.id,
              values: { renewedFromId },
            })
          );
        }}
        disabled={disabled}
        fullWidth
      >
        <MenuItem value={NONE_KEY}>{"None"}</MenuItem>
        {choices.map(({ key, name }) => (
          <MenuItem key={key} value={key}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RenewedFromLayerSelector;
